// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__Qgoki","control-dots":"Carousel_control-dots__9xg8s","dot":"Carousel_dot__yaHbi","selected":"Carousel_selected__n6YQk"};